import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getUnreadCountAnnouncementsSlice = createApi(`GetUnreadCountAnnouncementsSlice`,"GET");

const GetUnreadCountAnnouncementsSlice = createSlice({
  name: 'GetUnreadCountAnnouncementsSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUnreadCountAnnouncementsSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUnreadCountAnnouncementsSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getUnreadCountAnnouncementsSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetUnreadCountAnnouncementsSlice.reducer;